import { useMemo } from 'react'

type TimelineRange = {
  start: number
  end: number
}

const useVisibleTimelineTicks = ({
  minorTickTimes,
  minuteTickTimes,
  visibleRange,
}: {
  minorTickTimes: number[]
  minuteTickTimes: number[]
  visibleRange: TimelineRange
}) => {
  const visibleMinorTickTimes = useMemo(
    () =>
      minorTickTimes.filter(
        (tickAt) => tickAt >= visibleRange.start && tickAt <= visibleRange.end,
      ),
    [minorTickTimes, visibleRange.end, visibleRange.start],
  )

  const visibleMinuteTickTimes = useMemo(
    () =>
      minuteTickTimes.filter(
        (tickAt) => tickAt >= visibleRange.start && tickAt <= visibleRange.end,
      ),
    [minuteTickTimes, visibleRange.end, visibleRange.start],
  )

  return { visibleMinorTickTimes, visibleMinuteTickTimes }
}

export default useVisibleTimelineTicks
